__turbopack_context__.v({
  "icon": "_0KJTaW_icon",
  "tooltip": "_0KJTaW_tooltip",
});
